// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Notification Bell Container */
.notification-bell {
  position: relative;
  display: inline-block;
}

.notification-bell--menu {
  display: block;
  width: 100%;
}

.notification-bell--menu .notification-bell-button {
  justify-content: flex-start;
  width: 100%;
}

.notification-bell--menu .notification-badge {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

/* Bell Button */
.notification-bell-button {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: color 0.2s;
  border-radius: 8px;
}

.notification-bell-button:hover {
  color: #2563eb;
  background-color: #f1f5f9;
}

/* Unread Badge */
.notification-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #ef4444;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 5px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  line-height: 1.2;
}

/* Dropdown Container */
.notification-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 380px;
  max-height: 500px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Header */
.notification-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.notification-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.mark-all-read {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #2563eb;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.mark-all-read:hover {
  background-color: #dbeafe;
}

/* Notification List */
.notification-list {
  flex: 1 1;
  overflow-y: auto;
  max-height: 400px;
}

.notification-loading,
.notification-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #94a3b8;
  gap: 12px;
}

.notification-empty svg {
  color: #cbd5e1;
}

.notification-empty p {
  margin: 0;
  font-size: 14px;
}

/* Individual Notification Item */
.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}

.notification-item:hover {
  background-color: #f8fafc;
}

.notification-item.unread {
  background-color: #eff6ff;
}

.notification-item.unread:hover {
  background-color: #dbeafe;
}

/* Unread indicator dot */
.notification-item.unread::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 22px;
  width: 6px;
  height: 6px;
  background-color: #2563eb;
  border-radius: 50%;
}

/* Notification Content */
.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.notification-message {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 6px;
  line-height: 1.4;
}

.notification-time {
  font-size: 11px;
  color: #94a3b8;
}

/* Delete Button */
.notification-delete {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.notification-delete:hover {
  color: #ef4444;
  background-color: #fee2e2;
}

/* Responsive */
@media (max-width: 480px) {
  .notification-dropdown {
    width: 320px;
    right: -20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationBell.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["/* Notification Bell Container */\n.notification-bell {\n  position: relative;\n  display: inline-block;\n}\n\n.notification-bell--menu {\n  display: block;\n  width: 100%;\n}\n\n.notification-bell--menu .notification-bell-button {\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.notification-bell--menu .notification-badge {\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n/* Bell Button */\n.notification-bell-button {\n  position: relative;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  transition: color 0.2s;\n  border-radius: 8px;\n}\n\n.notification-bell-button:hover {\n  color: #2563eb;\n  background-color: #f1f5f9;\n}\n\n/* Unread Badge */\n.notification-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background-color: #ef4444;\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 5px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n/* Dropdown Container */\n.notification-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 380px;\n  max-height: 500px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.notification-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.mark-all-read {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  color: #2563eb;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 6px;\n  transition: background-color 0.2s;\n}\n\n.mark-all-read:hover {\n  background-color: #dbeafe;\n}\n\n/* Notification List */\n.notification-list {\n  flex: 1;\n  overflow-y: auto;\n  max-height: 400px;\n}\n\n.notification-loading,\n.notification-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #94a3b8;\n  gap: 12px;\n}\n\n.notification-empty svg {\n  color: #cbd5e1;\n}\n\n.notification-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Individual Notification Item */\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  position: relative;\n}\n\n.notification-item:hover {\n  background-color: #f8fafc;\n}\n\n.notification-item.unread {\n  background-color: #eff6ff;\n}\n\n.notification-item.unread:hover {\n  background-color: #dbeafe;\n}\n\n/* Unread indicator dot */\n.notification-item.unread::before {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 22px;\n  width: 6px;\n  height: 6px;\n  background-color: #2563eb;\n  border-radius: 50%;\n}\n\n/* Notification Content */\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.notification-message {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 6px;\n  line-height: 1.4;\n}\n\n.notification-time {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n/* Delete Button */\n.notification-delete {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.notification-delete:hover {\n  color: #ef4444;\n  background-color: #fee2e2;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .notification-dropdown {\n    width: 320px;\n    right: -20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
